module.exports = __webpack_public_path__ + "static/media/twitter_share.40e964e1.svg";